import { render, staticRenderFns } from "./changePasswordForm.vue?vue&type=template&id=21a18131&"
import script from "./changePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./changePasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./changePasswordForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports